import { DataSubject } from '@main/datamap-types';
import React from 'react';
import { useIntl } from 'react-intl';

import { FocusButtonWrapper, SubjectWrapper } from './wrappers';

/** Data subject list items for use with DataSubjectList */
export interface DataSubjectListItemProps {
  /** the data subject associated with the label */
  subject: DataSubject;
  /** onClick function */
  onClick: () => void;
  /** indicates active data subject styling should be used */
  active: boolean;
}

export const DataSubjectListItem = ({
  subject,
  onClick,
  active,
}: DataSubjectListItemProps): JSX.Element => {
  const { formatMessage } = useIntl();
  return (
    <FocusButtonWrapper
      onClick={onClick}
      id={`select-dataSubject-${subject.type}`}
      aria-current={active}
    >
      <SubjectWrapper active={active}>
        {formatMessage(subject.title)}
      </SubjectWrapper>
    </FocusButtonWrapper>
  );
};
